import { useMemo } from 'react';
import { CuisineCategory } from 'src/gqlReactTypings.generated.d';
import { useCachedDishFirstFilters } from 'src/pages/consumer/dish-first/explore/hooks';

// Typeguard
export const isCuisineCategory = (item: any): item is CuisineCategory => item?.__typename === 'CuisineCategory';

interface IProps {
  subcuisineId?: string;
  ancestorIds: string[];
}

interface IResponse {
  isSubcuisineOf: boolean;
  cuisineCategory?: CuisineCategory;
}

export const useGetCuisineCategoryById = (subcuisineId?: string): CuisineCategory | null => {
  const { allCuisineCategories } = useCachedDishFirstFilters();

  return useMemo(() => {
    if (!subcuisineId) return null;
    const cuisineCategory = allCuisineCategories.find((c) => c.id === subcuisineId);
    if (!cuisineCategory || !isCuisineCategory(cuisineCategory)) return null;
    return cuisineCategory;
  }, [allCuisineCategories, subcuisineId]);
};

export const useIsSubcuisineOf = ({ subcuisineId, ancestorIds }: IProps): IResponse => {
  const { allCuisineCategories } = useCachedDishFirstFilters();
  return useMemo(() => {
    if (!subcuisineId) return { isSubcuisineOf: false };

    const cuisineCategory = allCuisineCategories.find((c) => c.id === subcuisineId);
    if (!cuisineCategory || !isCuisineCategory(cuisineCategory)) return { isSubcuisineOf: false };

    const isSubcuisineOf =
      ancestorIds.includes(cuisineCategory.id) ||
      !!cuisineCategory?.ancestorCuisines?.some((a) => ancestorIds.includes(a.id));
    return { isSubcuisineOf, cuisineCategory };
  }, [allCuisineCategories, ancestorIds, subcuisineId]);
};
